export const modalTypes = {
    INFO: 'info',
    SEND_EMAIL: 'send-email',
    PRINT: 'print',
    SAVE: 'save',
    WEBSHOP: 'webshop',
    REJECT: 'reject',
    APPROVE: 'approve',
    ERROR: 'error',
    APPROVE_WITH_WARNING: 'approve-with-warning'
};

// statusTypes are the IDs that backend set fo each state
export const statusTypes = {
    APPROVED: '1',
    REJECTED: '2',
    OPEN: '3',
    PENDING_APPROVAL: '4'
}
